import { LineChartOutlined, PaperClipOutlined, PieChartOutlined } from "@ant-design/icons";
import { Box, HStack, Image, SimpleGrid, VStack } from "@chakra-ui/react";
import { Button, Skeleton, Space } from "antd";
import { StaffRoutes } from "appRoutePaths";
import { Roles, useIdentity } from "context/auth";
import useProfile from "hooks/useProfile";
import { FC, Suspense, useState } from "react";
import AdminDashboardCard from "./AdminDashboardCard";
import AdminDashboardData from "./AdminDashboardData";
import ResourceUsage from "./ResourceUsage";

const backgroundImage = require("images/staff_dashboard.jpg");

const SkeletonCard = () => <VStack
    bg="white"
    rounded={3}
    p={3}
    align="left"
    spacing={2}>
    <Box>
        <Box pb={1}><Skeleton.Input active /></Box>
        <Box pt={1}><Skeleton.Input active size="small" block /></Box>
    </Box>
    <Box>
        <Skeleton.Input active block />
    </Box>
    <Box w="100%" h={1} bg="lightGreen" />
    <Skeleton.Input active size="small" />
</VStack>;

const SkeletonGrid = () => <SimpleGrid columns={2} spacing={6} pb={6}>
    <SkeletonCard /><SkeletonCard />
    <SkeletonCard /><SkeletonCard />
    <SkeletonCard /><SkeletonCard />
</SimpleGrid>;

const AdminDashboard: FC = () => {
    const { data: profile } = useProfile();
    const { isAdmin, isInRole } = useIdentity();
    const [open, setOpen] = useState(false);
    const name = profile?.firstName ?? "Admin";

    const isSeniorStaff = isInRole([Roles.SeniorStaff]);
    const isStaff = isInRole([Roles.Staff]);

    return (
        <VStack
            align="start"
            h="100%"
            w="100%"
            bg="transparent"
            pos="relative"
            fontFamily="body"
        >
            <Image
                pos="absolute"
                zIndex={-1}
                src={backgroundImage}
                alt="DC Sports 87"
                objectFit="cover"
                objectPosition="top"
                w="100%"
                h="100%"
            />
            <Box p={6}>
                <HStack display='flex' justifyContent='space-between'>
                    <Box color="white" fontSize={42}>
                        Hi, {name}
                    </Box>
                    <Space>
                        {isAdmin && <Button
                            size="large"
                            icon={<PieChartOutlined />}
                            onClick={() => setOpen(true)}>
                            eBay API Usage
                        </Button>}
                        {isAdmin && <Button
                            size="large"
                            icon={<LineChartOutlined />}
                            href={StaffRoutes.shipmentMetrics.url}>
                            Shipment Metrics
                        </Button>}
                        {(isAdmin || isSeniorStaff) && <Button
                            size="large"
                            icon={<PaperClipOutlined />}
                            href={StaffRoutes.auditLog.url}>
                            Audit Log
                        </Button>}
                    </Space>
                </HStack>
                <Suspense fallback={<SkeletonGrid />}>
                    <AdminDashboardData isAdmin={isAdmin!!} isStaff={isStaff || isSeniorStaff} />
                </Suspense>
                {isAdmin && <AdminDashboardCard
                    title="Need to update current wait times or push notifications globally?"
                    linkText="Go to Website Updates Page"
                    linkTo={StaffRoutes.websiteUpdates.url}
                />}
            </Box>
            <ResourceUsage open={open} onClosed={() => setOpen(false)} />
        </VStack>
    );
};

export default AdminDashboard;
